<template>
    <div v-if="show" :class="['relative border-l-4 px-4 py-3', style, { 'pr-16': closable }]" role="alert">
        <slot></slot>

        <button
            v-if="closable"
            class="absolute leading-none opacity-50 hover:opacity-75 top-0 right-0 px-4 py-3 font-bold text-2xl"
            aria-label="Close"
            style="color: inherit"
            @click="show = false"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'info'
        },
        closable: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            show: true,
            styleMapping: {
                info: {
                    bgColor: 'bg-blue-100',
                    leftBorderColor: 'border-blue-500',
                    textColor: 'text-blue-700'
                },
                success: {
                    bgColor: 'bg-green-200',
                    leftBorderColor: 'border-green-600',
                    textColor: 'text-green-700'
                },
                error: {
                    bgColor: 'bg-red-200',
                    leftBorderColor: 'border-red-600',
                    textColor: 'text-red-700'
                },
                warning: {
                    bgColor: 'bg-orange-100',
                    leftBorderColor: 'border-orange-500',
                    textColor: 'text-orange-700'
                }
            }
        };
    },

    computed: {
        style: function() {
            let styleForType = this.styleMapping[this.type];

            return `${styleForType.bgColor} ${styleForType.leftBorderColor} ${styleForType.textColor}`;
        }
    }
};
</script>
